/**
 * Allergies Service
 * Patient allergy tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AllergyGroupResponseDto { 
    /**
     * Allergy group identifier
     */
    id: string;
    /**
     * Group name
     */
    name: string;
    /**
     * URL-friendly slug
     */
    slug: string;
    /**
     * Group description
     */
    description?: string;
    /**
     * Group status
     */
    status: AllergyGroupResponseDto.StatusEnum;
    /**
     * Metadata
     */
    metadata?: any;
    /**
     * Number of allergy types in group
     */
    elementCount?: number;
    /**
     * Created on
     */
    createdOn?: string;
    /**
     * Updated on
     */
    updatedOn?: string;
}
export namespace AllergyGroupResponseDto {
    export type StatusEnum = 'draft' | 'active' | 'inactive';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


